/* ------------------------------------------ */
/* Theme custom JavaScript.                   */
/*                                            */
/* This file is inserted in theme.liquid      */
/* after the main JavaScript file.            */
/*                                            */
/* ------------------------------------------ */

$(function() {

  // Add rel="noopener" to all links that are opened in new window for improved security
  // https://web.dev/external-anchors-use-rel-noopener/
  $('a[target]').attr('rel', 'noopener');

  // Apply only on product page
  if ( $('.template--product').length > 0 ) {

    //Swiper JS for Product Media Gallery
    swiperGallery(); 

    // Enable and disable product form submit on serial number field value change
    serialNumberFieldChange(); 

    // Initialize Fancybox
    Fancybox.bind("[data-fancybox='gallery']", {
        infinite: true
    });

    // Add accordion functionality to product page
    productAccordion(); 

  }

  // Make contact form email field voluntary
  contactFormEmail(); 

  // Validate contact form phone field
  contactFormPhone(); 

  // Create a drawer for the search form
  searchForm(); 

  // Create a navigation menu and drawer 
  navigationMenu(); 

  // Accessibility fixes
  betterAccessibility(); 

  // Add collection view mode functionality to collection pages
  collectionViewMode();

  // Show youtube video if user has accepted marketing cookies for CookieHub
  if (typeof window.cookiehub !== "undefined" && window.cookiehub.hasConsented('marketing')) {
    $('iframe[data-consent="marketing"]').each(function() {
      this.src = $(this).attr('data-src');
    });
   $('.placeholder').hide();
  }

  // Fix styles loading for iPhone 
  if ( navigator.userAgent.includes('iPhone') ) {
    window.dispatchEvent(new Event('resize'));
  }

});


function swiperGallery() {

  var swiperThumbs = new Swiper(".swiper-thumbs", {
    spaceBetween: 20,
    slidesPerView: 10,
    keyboard: {
      enabled: false
    }
  });

  var swiperMain = new Swiper(".swiper-main", {
    spaceBetween: 10,
    thumbs: {
        swiper: swiperThumbs,
    },
  });

}

function serialNumberFieldChange() {

  $serialNumberField = $('#serial-number');
  $productFormSubmit =  $('.product-form__submit');

  $serialNumberField.keyup(function () {

    if ( $(this).val().trim() !== '' ) {
      $productFormSubmit.prop('disabled','');
    } else {
      $productFormSubmit.prop('disabled','true');
    }
    
  });
}

// Function to handle the display of the serial number field for software update products
// This function is called by the updateMasterId method in global.js 
async function softwareVariantChange(variantId) {

  // Fetch the metafield data for the specified product variant
  const data = await fetchVariantDataWithMetafields(variantId);

  // jQuery selectors 
  $serialNumberContainer = $('.serial-number-container');
  $serialNumberField = $('#serial-number');
  $productFormSubmit =  $('.product-form__submit');

  // Check if the product variant is a software update and the serial number container is hidden
  if ( data.node.metafield.value === 'true' ) {

    // Show the serial number container 
    $serialNumberContainer.removeClass('hidden');

    // Enable serial number input field
    $serialNumberField.removeAttr('disabled');

    // Focus on serial number input field
    $serialNumberField.focus(); 

    // Disable product form submit before serial number field if it is empty
    setTimeout(() => {
      if ( $serialNumberField.val().trim() === '' ) {
        $productFormSubmit.prop('disabled','true');
      }
    }, "500");
  

  // Check if the product variant is not a software update
  } else if ( data.node.metafield.value === 'false' ) {

    // Hide the serial number container and disable the input field
    $serialNumberContainer.addClass('hidden');
    $serialNumberField.prop('disabled', true);
    
  }
  
}

// Function to fetch metafield data for a given product variant using the Storefront API
async function fetchVariantDataWithMetafields(variantId) {

  // Storefront API access token
  const storefrontAccessToken = '6af2dbbae87d3a343e1e53d67c36d9e1';

  // Encode the product variant ID for the GraphQL query
  const encodedVariantID = `gid://shopify/ProductVariant/${variantId}`;

  // GraphQL query to fetch the software update metafield for the specified variant
  const query = `
      {
        node(id: "${encodedVariantID}") {
        ... on ProductVariant {
          id
          title
          metafield(key: "software_update", namespace: "custom") {
            value
            id
          }
        }
      }
    }
  `;

  // Fetch the metafield data using the Storefront API
  try {
    const response = await fetch('https://nakopiste.myshopify.com/api/2024-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': `${storefrontAccessToken}`,
      },
      body: JSON.stringify({ query })
    });

    // Parse the response data
    const responseData = await response.json();

    // Return the fetched data
    return responseData.data; 

  // Handle any errors that occur during the fetch
  } catch (error) {
    console.error('Fetch error:', error);
    return null;
  }
}

function contactFormEmail() {

  const ContactFormElement = document.getElementById("ContactForm-submit");

  if (ContactFormElement != null) {

    ContactFormElement.addEventListener("click", function (event) {

      const email = document.getElementById('ContactForm-email');

      // If the email field is empty, set the default email
      if (email.value === '') {
        email.value = 'info@polarprint.fi';
        email.style.textIndent = "-999px";  
        return false;
      }

      return true;

    }, false);
  }

}

function contactFormPhone() {

  $('#ContactForm').submit(function (e) {

    e.preventDefault(); 

    const phonePattern = /^[0-9+-]+$/;

    const $phone = $(this).find('#ContactForm-phone'); 

    if ( $phone.val() == '' ) {
      this.submit(); 
    } else if (!phonePattern.test($phone.val())) {
      $('#ContactForm-tel-error').removeClass('hidden');
      $('#ContactForm-tel-error .form__message').focus(); 
      return false; 
    } else {
      this.submit(); 
    }

  
  });

}

function searchForm() {

    // Create a drawer for the search form
    // $('#drawer--site-search').drawer({
    //   translations: { 
    //     'show-label': '<span class="assistive text">Näytä hakukenttä</span>',
    //     'hide-label': '<span class="assistive text">Piilota hakukenttä</span>'
    //   }, // Text translations
    //   toggleButton: '#drawer-toggle--site-search', // A jQuery object / an element / a selector string that opens and closes the drawer (should be a button; if null, a new button is created)
    //   group: 'header', // Drawer group's name (automatically closes other drawers of the same group when opened)
    //   state: 'open', // Drawer's initial state
    //   click: true, // Click interaction
    //   clickShowSpeed: 500, // Click show speed (ms)
    //   clickHideSpeed: 500, // Click hide speed (ms)
    //   clickDelay: 0, // Click delay speed (ms)
    //   hoverElement: '#area--site-search', // A jQuery object / an element / a selector string that opens and closes the drawer on hover
    //   hover: false, // Hover interaction
    //   hoverShowSpeed: 500, // Hover show speed (ms)
    //   hoverHideSpeed: 500, // Hover hide speed (ms)
    //   hoverDelay: 500, // Hover delay speed (ms)
    //   transition: 'slide', // Transition: 'fade' (default) or 'slide'
    //   easing: 'swing' // Easing: 'swing' (default) or 'linear'
    // });

    $('#drawer-toggle--site-search').click(function(e) {
      if ( $(e.target).is('.closed') ) {
        $(e.target).toggleClass('closed');
        $('#Search-In-Modal').focus(); 
      } else {
        $(e.target).toggleClass('closed');
      }
    });

    $('#Search-In-Modal,#button--site-search').on('focus', function() {
      $('#form--site-search').css('opacity', '1');
    });
    $('#Search-In-Modal,#button--site-search').on('focusout', function() {
      $('#form--site-search').css('opacity','0');
    });

}

function navigationMenu() {

    // Create a drawer for the navigation menu
    $('#drawer--main-navigation').drawer({
      translations: { 
        'show-label': '<span class="assistive text">Näytä päänavigaatio</span>',
        'hide-label': '<span class="assistive text">Piilota päänavigaatio</span>'
      }, // Text translations
      toggleButton: '#drawer-toggle--main-navigation', // A jQuery object / an element / a selector string that opens and closes the drawer (should be a button; if null, a new button is created)
      group: 'header', // Drawer group's name (automatically closes other drawers of the same group when opened)
      state: 'closed', // Drawer's initial state
      click: true, // Click interaction
      clickShowSpeed: 750, // Click show speed (ms)
      clickHideSpeed: 750, // Click hide speed (ms)
      clickDelay: 0, // Click delay speed (ms)
      hoverElement: '#area--main-navigation', // A jQuery object / an element / a selector string that opens and closes the drawer on hover
      hover: false, // Hover interaction
      hoverShowSpeed: 750, // Hover show speed (ms)
      hoverHideSpeed: 750, // Hover hide speed (ms)
      hoverDelay: 500, // Hover delay speed (ms)
      transition: 'slide', // Transition: 'fade' (default) or 'slide'
      easing: 'swing' // Easing: 'swing' (default) or 'linear'
    });
  
    // Create a main navigation menu
    $('#navigation-menu--main').navigationMenu({
      translations: {
        'name': 'Päänavigaatio', // Navigation menu's aria-label attribute
        'expand-label': 'Näytä alivalikko', // Expand button label
        'collapse-label': 'Piilota alivalikko' // Collapse button label
      }, // Text translations
      click: true, // Click interaction
      clickShowSpeed: 500, // Click show speed (ms)
      clickHideSpeed: 500, // Click hide speed (ms)
      hover: true, // Hover interaction
      hoverShowSpeed: 500, // Hover show speed (ms)
      hoverHideSpeed: 500, // Hover hide speed (ms)
      simultaneous: false, // Allow hover interaction even when a submenu is expanded
      transition: 'slide', // Transition: 'fade' (default) or 'slide'
      easing: 'swing' // Easing: 'swing' (default) or 'linear'
    });


}

function betterAccessibility() {

  // Hide focus rectangles if element was focused by other means than keyboard
  // https://medium.com/better-programming/a11y-never-remove-the-outlines-ee4efc7a9968
  // When user clicks the page with a mouse or touches it
  $(document).on('mousedown touchstart', function (e) {
    // Add mouse-focused marking to HTML root
    $('html').addClass('mouse-focused');
    // Add mouse-focused marking to element
    //$(e.currentTarget).addClass('mouse-focused');
    });
    // When user uses keyboard
    $(document).on('keydown', function (e) {
      // Remove mouse-focused marking from HTML root
      $('html').removeClass('mouse-focused');
    });
    // When element gets focus
    $(document).on('focus', 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, video, audio, *[tabindex], *[contenteditable]', function (e) {
      if ($('html').hasClass('mouse-focused')) {
        // Add mouse-focused marking to element
        $(e.target).addClass('mouse-focused');
      }
    });
    // When element loses focus
    $(document).on('blur', 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, video, audio, *[tabindex], *[contenteditable]', function (e) {
      if (!$('html').hasClass('mouse-focused')) {
        // Remove mouse-focused marking from element
        $(e.target).removeClass('mouse-focused');
      }
    });

    // Mark all A elements based on the 'href' attribute's anchor, protocol, file type, host values and and target attribute's value
    $('a:not([role="button"], .more-link, .pagination__item, .footer-block a, .header-banner, .icon-button, .skip-link, .swiper-slide a, .form__message a, [href="#recover"], [href="#login"])').accessibleLinks({});

}

window.collectionViewMode = function() {
   
  // Create cookie name variable
  var cookieName = 'collection-view-mode';

  // Set default grid view for empty cookie
  if ( document.readCookie('collection-view-mode') == null ) {
    document.writeCookie(cookieName, 'grid');
  }

  // Get the current collection view mode from cookie
  var currentMode = document.readCookie(cookieName);

  // Create jQuery Objects 
  var $gridButton = $('#button--grid-view');
  var $listButton = $('#button--list-view');
  var $gridView = $('.grid-view');
  var $listView = $('.list-view');

  // Show initial state based on cookie
  if (currentMode == 'list') {
    $listButton.addClass('active').attr('aria-expanded', 'true');
    $gridButton.removeClass('active').attr('aria-expanded', 'false');
    $listView.css({'display': 'block'});
    $gridView.css({'display': 'none'});
  }
  else {
    $gridButton.addClass('active').attr('aria-expanded', 'true');
    $listButton.removeClass('active').attr('aria-expanded', 'false');
    $gridView.css({'display': 'block'});
    $listView.css({'display': 'none'});
  }

  // Remove old event handlers
  $gridButton.off(); 

  // Add button click event to show grid view
  $gridButton.on('click', function (e) {
    
    // Show the grid view
    $listButton.removeClass('active').attr('aria-expanded','false');
    $gridButton.addClass('active').attr('aria-expanded','true');
    $gridView.css({'position': 'relative', 'display': 'block', 'visibility': 'hidden', 'z-index': '1'}).delay(490).css({'visibility': 'visible', 'opacity': '0'}).animate({'opacity': '1'}, 510, 'swing', function () {
    });
    $listView.css({'position': 'absolute', 'opacity': '1', 'z-index': '0'}).animate({'opacity': '0'}, 510, 'swing', function () {
      $listView.css({'display': 'none'});
    });
    // Save the view mode to cookie
    document.writeCookie(cookieName, 'grid');
  });

  // Remove old event handlers
  $listButton.off(); 

  // Add button click event to show list view
  $listButton.on('click', function (e) {
    
    // Show the list view
    $gridButton.removeClass('active').attr('aria-expanded','false');
    $listButton.addClass('active').attr('aria-expanded','true');
    $listView.css({'position': 'relative', 'display': 'block', 'visibility': 'hidden', 'z-index': '1'}).delay(490).css({'visibility': 'visible', 'opacity': '0'}).animate({'opacity': '1'}, 510, 'swing', function () {
    });
    $gridView.css({'position': 'absolute', 'opacity': '1', 'z-index': '0'}).animate({'opacity': '0'}, 490, 'swing', function () {
      $gridView.css({'display': 'none'});
    });
    // Save the view mode to cookie
    document.writeCookie(cookieName, 'list');
  });
 
}

function productAccordion() {

  $('.js-accordion-item').each(function () {
  
    // This accordion item
    var $this = $(this);
  
    // The controller element
    var $controller = $this.find('.js-accordion-controller');
  
    // The content element
    var $content = $this.find('.c-accordion__content');
  
    // The controller element's hash anchor
    var hash = '#' + $controller.attr('id');
  
    // Remove H2 element's role
    $controller.removeAttr('role');
  
    // If this accordion item is initially closed and it's not the current hash anchor item
    if (
      $this.attr('data-initially-open') === 'false' &&
      hash !== window.location.hash
    ) {
      // Hide this element
      $content.hide();
    }
  
    // Create an A element as a suitable focusable trigger element and wrap H2 element's content with it
    $controller.wrapInner('<a href="#' + $controller.attr('id') + '" role="button" tabindex="0" aria-controls="' + $content.attr('id') + '" style="cursor: pointer;"></a>');
  
    // The button element we just created
    var $button = $controller.find('a[role="button"]');
  
    // Set the button's 'aria-expanded' attribute based on if the content is visible or not
    $button.attr('aria-expanded', ($content.is(':visible') ? 'true' : 'false'));
  
    // On button click
    $button.on('click', function (e) {
      // Set the button's 'aria-expanded' attribute based on if the content is going to be visible or not
      $button.attr('aria-expanded', ($button.attr('aria-expanded') === 'false' ? 'true' : 'false'));
      // Toggle content visibility with slide effect
      $content.slideToggle(250);
      // Prevent the default link functionality
      e.preventDefault();
    });
  
  });

}

// Cookie helper functions
// https://www.quirksmode.org/js/cookies.html

// Write cookie
document.writeCookie = function (name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = '; expires=' + date.toGMTString();
  }
  else var expires = '';
  document.cookie = name + '=' + value + expires + '; path=/';
};

// Read cookie
document.readCookie = function (name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Delete cookie
document.deleteCookie = function (name) {
  // The negative expiration time causes the cookie to be instantly deleted by the browser
  writeCookie(name, '', -1);
};

